import { Strain } from "custom-types/Strain";
import { getTopEffects } from "utils/strains/effectShoppingUtils";

export const getShopNowUrl = (strain: Strain) => {
  const topEffects = getTopEffects(strain.effects);

  const params = new URLSearchParams({
    boost: "strain_name",
    ...(strain?.name && { "boost_options[strain_name]": strain.name }),
    fulfillmentPreference: "pickup",
  });

  topEffects.forEach((effect) => {
    params.append("top_strain_effects_included", effect);
  });

  return `/shop?${params.toString()}`;
};
